// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"76":"dda5318f30b39ee8","983":"778d31f38e41adb2"}[chunkId] + ".css";
};